export default __webpack_public_path__ + "static/media/find_radon_pro.5e70a945.png";